var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharacter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_1923086",
    clipPath: "url(#clip0_4389_9512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.6883 65.8708H16.7423C16.7423 59.266 22.1566 54.7817 22.1566 54.7817H43.8433C43.8433 54.7817 49.2577 59.2659 49.2577 65.8708H38.3117L33 63.215L27.6883 65.8708Z",
    fill: "#D97C40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.8074 54.782H22.1567C22.1567 54.782 16.7423 59.2661 16.7423 65.8711H19.3931C19.3931 59.2663 24.8074 54.782 24.8074 54.782Z",
    fill: "#AF602D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M59.1807 62.571L57.9594 60.6745C57.9594 60.6745 47.146 60.3793 45.7566 68.5325L48.1484 69.6753C51.637 69.3926 59.1807 62.571 59.1807 62.571Z",
    fill: "#D97C40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.6978 16.3976C18.2259 16.3976 21.8966 12.7269 21.8966 8.19881C21.8966 3.67073 18.2259 0 13.6978 0C9.16971 0 5.49898 3.67073 5.49898 8.19881C5.49898 12.7269 9.16971 16.3976 13.6978 16.3976Z",
    fill: "#AF602D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.3036 11.3489C15.2612 11.3489 16.8481 9.76203 16.8481 7.80448C16.8481 5.84692 15.2612 4.26001 13.3036 4.26001C11.3461 4.26001 9.75916 5.84692 9.75916 7.80448C9.75916 9.76203 11.3461 11.3489 13.3036 11.3489Z",
    fill: "#FFAACB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M52.3021 16.3976C56.8301 16.3976 60.5009 12.7269 60.5009 8.19881C60.5009 3.67073 56.8301 0 52.3021 0C47.774 0 44.1032 3.67073 44.1032 8.19881C44.1032 12.7269 47.774 16.3976 52.3021 16.3976Z",
    fill: "#AF602D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M52.6964 11.3489C54.6539 11.3489 56.2408 9.76203 56.2408 7.80448C56.2408 5.84692 54.6539 4.26001 52.6964 4.26001C50.7388 4.26001 49.1519 5.84692 49.1519 7.80448C49.1519 9.76203 50.7388 11.3489 52.6964 11.3489Z",
    fill: "#FFAACB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M33 56.9433C48.5711 56.9433 61.1939 44.3204 61.1939 28.7493C61.1939 13.1783 48.5711 0.55542 33 0.55542C17.4289 0.55542 4.80608 13.1783 4.80608 28.7493C4.80608 44.3204 17.4289 56.9433 33 56.9433Z",
    fill: "#DE8957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M8.78222 28.7493C8.78222 13.8469 20.3449 1.64647 34.9881 0.626195C34.3312 0.58047 33.6685 0.55542 33 0.55542C17.4289 0.55542 4.80608 13.1784 4.80608 28.7493C4.80608 44.3205 17.4289 56.9433 33 56.9433C33.6685 56.9433 34.3312 56.9183 34.9881 56.8725C20.3449 55.8522 8.78222 43.6519 8.78222 28.7493Z",
    fill: "#D97C40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M38.3116 65.8708H27.6883C27.6883 62.9376 30.0667 60.5591 33 60.5591C35.9333 60.5591 38.3116 62.9376 38.3116 65.8708Z",
    fill: "#E8A882"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M45.7754 64.7271L43.28 61.5227C42.9428 61.0896 42.3182 61.0119 41.885 61.3492C41.4519 61.6865 41.3742 62.3111 41.7115 62.7442L44.2068 65.9486L45.7754 64.7271Z",
    fill: "#AF602D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M23.556 65.8716V61.8102C23.556 61.2612 23.1109 60.8162 22.562 60.8162C22.013 60.8162 21.5679 61.2612 21.5679 61.8102V65.8716H23.556Z",
    fill: "#AF602D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M21.8966 9.69759C22.4456 9.69759 22.8906 9.25252 22.8906 8.70355V6.73549C22.8906 6.18652 22.4456 5.74146 21.8966 5.74146C21.3476 5.74146 20.9026 6.18652 20.9026 6.73549V8.70355C20.9026 9.25252 21.3476 9.69759 21.8966 9.69759Z",
    fill: "#423E4F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M44.1032 9.69759C44.6522 9.69759 45.0973 9.25252 45.0973 8.70355V6.73549C45.0973 6.18652 44.6522 5.74146 44.1032 5.74146C43.5543 5.74146 43.1092 6.18652 43.1092 6.73549V8.70355C43.1092 9.25252 43.5543 9.69759 44.1032 9.69759Z",
    fill: "#423E4F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M37.7772 9.17343C37.364 8.81213 36.7359 8.85415 36.3746 9.26753C36.0566 9.63122 35.578 9.83983 35.0614 9.83983C34.5447 9.83983 34.0661 9.63122 33.7483 9.26767C33.5626 9.05441 33.2818 8.92876 32.9996 8.92876C32.717 8.92876 32.4376 9.05468 32.2514 9.26767C31.9335 9.63135 31.4549 9.83996 30.9382 9.83996C30.4216 9.83996 29.943 9.63135 29.6252 9.2678C29.2639 8.85441 28.6359 8.81226 28.2225 9.17356C27.8091 9.53486 27.7669 10.1628 28.1283 10.5762C28.8237 11.3718 29.8478 11.8282 30.9382 11.8282C31.6844 11.8282 32.3996 11.6141 32.9997 11.2242C33.5999 11.6141 34.3149 11.8282 35.0612 11.8282C36.1515 11.8282 37.1757 11.3718 37.8712 10.5762C38.2327 10.1627 38.1906 9.53473 37.7772 9.17343Z",
    fill: "#423E4F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M34.2831 5.68066H31.7169C30.9597 5.68066 30.5137 6.53925 30.9569 7.15316C31.4143 7.7867 32.159 8.19902 33.0001 8.19902C33.8412 8.19902 34.586 7.7867 35.0433 7.15316C35.4863 6.53925 35.0403 5.68066 34.2831 5.68066Z",
    fill: "#423E4F"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M35.7732 57.6966C35.7732 57.6966 41.6577 64.2483 41.6577 55.3966C41.6577 46.545 35.7732 53.0967 35.7732 53.0967V57.6966Z",
    fill: "#FF82B3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M30.2268 57.6966C30.2268 57.6966 24.3423 64.2483 24.3423 55.3966C24.3423 46.545 30.2268 53.0967 30.2268 53.0967V57.6966Z",
    fill: "#FF82B3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M33.901 52.4307H32.099C30.461 52.4307 29.1331 53.7586 29.1331 55.3966C29.1331 57.0346 30.461 58.3625 32.099 58.3625H33.901C35.539 58.3625 36.8669 57.0346 36.8669 55.3966C36.8669 53.7586 35.539 52.4307 33.901 52.4307Z",
    fill: "#FFAACB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M60.1054 62.473L59.55 61.481C59.4749 61.3469 59.1376 61.3929 58.7967 61.5838C58.4557 61.7747 58.2401 62.0382 58.3151 62.1723L58.8705 63.1643L60.1054 62.473Z",
    fill: "#AF602D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M59.4769 61.3505L58.9216 60.3584C58.8465 60.2243 58.5092 60.2703 58.1682 60.4612C57.8272 60.6521 57.6116 60.9156 57.6867 61.0497L58.2421 62.0418L59.4769 61.3505Z",
    fill: "#AF602D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M53.9394 22.2048C54.7043 24.0828 55.1195 26.2551 55.1195 28.7495C55.1195 40.9467 45.1973 48.1104 33.0001 48.1104C20.8029 48.1104 10.8807 40.9467 10.8807 28.7495C10.8807 26.8229 11.1277 25.0895 11.5929 23.5335C11.7296 23.0747 11.886 22.6319 12.0595 22.2048L17.7773 18.9336H47.7259L53.9394 22.2048Z",
    fill: "#FFDCCE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M43.6092 28.4497V29.7639C43.6092 30.0608 43.7992 31.2615 44.7235 31.2615C45.6478 31.2615 46.9565 31.2615 46.9565 29.7639V28.4497C46.9565 28.1528 46.2071 27.9121 45.2828 27.9121C44.3585 27.9121 43.6092 28.1528 43.6092 28.4497Z",
    fill: "#423E4F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M19.6033 28.4497V29.7639C19.6033 30.0608 19.7933 31.2615 20.7176 31.2615C21.6419 31.2615 22.9506 31.2615 22.9506 29.7639V28.4497C22.9506 28.1528 22.2013 27.9121 21.277 27.9121C20.3527 27.9121 19.6033 28.1528 19.6033 28.4497Z",
    fill: "#423E4F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M23.4176 36.8478C23.654 36.4944 22.6144 35.3846 21.7122 35.0632C20.81 34.7417 19.0689 33.0713 19.0689 33.0713C18.6305 32.7409 18.1638 32.6207 18.0266 32.8027C17.8894 32.9848 18.1336 33.4002 18.5721 33.7306C18.5721 33.7306 20.0908 34.9813 21.2154 35.7225C22.3399 36.4636 23.1789 37.2046 23.4176 36.8478Z",
    fill: "#FF889E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M48.5777 32.8771C48.2713 32.5102 46.8984 33.1777 46.3622 33.9848C45.8259 34.792 43.7189 35.9767 43.7189 35.9767C43.2805 36.3071 43.0501 36.7409 43.2044 36.9456C43.3586 37.1503 43.8392 37.0485 44.2776 36.7181C44.2776 36.7181 45.9049 35.6114 46.9209 34.7262C47.9369 33.8411 48.887 33.2475 48.5777 32.8771Z",
    fill: "#FF889E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M12.0601 22.2051C11.9734 22.4186 11.8908 22.6361 11.813 22.8576C10.0321 27.9232 10.7425 34.0861 13.5548 38.645C13.6401 38.7831 13.7271 38.92 13.8161 39.0553C17.6378 44.8768 24.8059 48.1107 33.0008 48.1107C33.3419 48.1107 33.684 48.104 34.0247 48.093C34.1856 48.093 34.3474 48.0804 34.5081 48.0727C34.668 48.0646 34.8276 48.0556 34.9888 48.045C23.7199 47.307 14.8576 40.2768 14.8576 28.7498C14.8576 26.8231 15.1046 25.0898 15.5698 23.5338C15.7065 23.0752 15.8629 22.6322 16.0364 22.2051H12.0601Z",
    fill: "#FFCABD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M53.9398 22.2036C52.8358 22.0288 51.6846 22.2338 50.6897 22.8187L50.6148 22.8634C49.081 23.7636 47.1807 23.7636 45.6471 22.8634L45.5709 22.8187C44.0372 21.9185 42.1368 21.9185 40.6032 22.8187L40.5284 22.8634C38.9946 23.7636 37.093 23.7636 35.5607 22.8634L35.4845 22.8187C33.9508 21.9185 32.0504 21.9185 30.5168 22.8187L30.4406 22.8634C28.9082 23.7636 27.0065 23.7636 25.4729 22.8634C25.448 22.8489 25.423 22.8331 25.3981 22.8187C23.8643 21.9185 21.964 21.9185 20.4304 22.8187L20.3542 22.8634C18.8205 23.7636 16.9201 23.7636 15.3865 22.8634L15.3116 22.8187C14.3155 22.2339 13.1643 22.0289 12.0603 22.2036C12.243 21.7555 12.444 21.3256 12.6649 20.9104C16.0516 14.551 23.8922 14.3262 33.0009 14.3262C40.526 14.3262 47.1851 14.4799 51.183 18.119C52.0241 18.8839 52.7482 19.8038 53.337 20.9104C53.5573 21.3258 53.7583 21.7555 53.9398 22.2036Z",
    fill: "#5C586F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M12.663 20.9112C12.5158 21.1881 12.3806 21.4742 12.2504 21.7652C12.1854 21.9106 12.1194 22.055 12.0584 22.2044C13.1623 22.0296 14.3135 22.2346 15.3097 22.8195C15.4402 22.8962 15.5848 22.9767 15.7263 23.0453C15.9737 22.3103 16.2748 21.5963 16.639 20.9112C19.776 15.021 26.734 14.3936 34.9813 14.3332C34.6782 14.331 34.3732 14.3296 34.0668 14.3287C34.0149 14.3286 33.9632 14.3284 33.9114 14.3283C32.6275 14.3283 31.3436 14.3254 30.0597 14.3429C28.6006 14.3601 27.1407 14.4053 25.6852 14.5119C19.8324 14.9388 15.0974 16.3404 12.663 20.9112Z",
    fill: "#423E4F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M35.8885 32.8121C35.4753 32.4508 34.8472 32.4931 34.4859 32.9063C34.1252 33.3188 33.5833 33.5554 32.9989 33.5554C32.4146 33.5554 31.8725 33.3188 31.5118 32.9062C31.1505 32.4928 30.5226 32.4508 30.1092 32.8121C29.6958 33.1734 29.6537 33.8014 30.0151 34.2148C30.7533 35.0593 31.8408 35.5436 32.9989 35.5436C34.157 35.5436 35.2445 35.0593 35.9827 34.2148C36.3442 33.8014 36.3019 33.1734 35.8885 32.8121Z",
    fill: "#423E4F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4389_9512"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65.8715,
    height: 65.8715,
    fill: "white",
    transform: "translate(0.0642548)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharacter);
export default __webpack_public_path__ + "static/media/character.0d446c22356d97be0551eb4a82d50ffb.svg";
export { ForwardRef as ReactComponent };